import React from "react";
import { Link } from "react-router-dom";
import { add_icon } from "../icons/add";
import { filters_icon } from "../icons/new_fillter";
import { search_icon } from "../icons/search";
import { useAuth } from "../store/authProvider";

const LgSearch = ({
  page,
  onSubmit,
  register,
  setShowFilters,
  text,
  priceSort,
  setPriceSort,
  setPage,
}) => {
  const { isAuth } = useAuth();

  const to = () => {
    let to;
    switch (page) {
      case 0:
        to = "/addform";
        break;
      case 1:
        to = "/addformOrder";
        break;
      case 4:
        to = "/addInput";
        break;
      case 5:
        to = "/addInputOrder";
        break;
      case 6:
        to = "/add_auction";
        break;
      default:
        to = "/addform";
        break;
    }

    return to;
  };
  return (
    <div className="hidden w-full col-span-5  lg:flex flex-row-reverse mb-10 h-10">
      <div className=" flex items-center justify-center h-[47px] text-sm font-bold text-white rounded-lg shadow-sm lg:h-full lg:text-lg  bg-primary  lg:w-[170px]">
        <Link to={isAuth ? to() : "/signin"}>
          <div className="flex flex-row-reverse items-center justify-center text-sm">
            <div className="">{add_icon}</div>
            <div className="">{text}</div>
          </div>
        </Link>
      </div>
      <div className="w-[15px]" />
      <div className="lg:w-1 h-1"></div>
      <div className="w-full">
        <form
          onSubmit={onSubmit}
          className="flex justify-center items-center h-full w-full flex-row-reverse"
        >
          <div className="rounded-full w-full border-[1px] border-primary h-full flex justify-end items-center px-3 ">
            <input
              type="text"
              {...register("search_word")}
              className="border-0 bg-transparent w-full focus:ring-0 text-gray-400 font-bold placeholder:text-sm placeholder:text-gray-400"
              dir="rtl"
              placeholder="أبحث عن طلبك..."
            />
            {search_icon}
          </div>
          <div className="w-[15px]" />
          <div
            className="h-full px-2 border-primary rounded-xl border-[2px] flex justify-center items-center hover:cursor-pointer"
            onClick={() => setShowFilters(true)}
          >
            {filters_icon}
          </div>
          <div className="w-[15px]" />
          <div className="h-full px-2 border-primary rounded-xl border-[2px] flex justify-center items-center hover:cursor-pointer">
            {filters_icon}

            <div className="w-[15px]" />
            <select
              value={priceSort ?? ""}
              onChange={(e) => {
                const val = e.target.value;
                setPage(1);
                setPriceSort(
                  val === "asc" ? "asc" : val === "desc" ? "desc" : null
                );
              }}
              className="appearance-none text-primary rounded-md border-none focus:outline-none focus:ring-0 pl-2 pr-6 py-1 text-center"
            >
              <option value="">الاحدث</option>
              <option value="asc"> سعر تصاعدي</option>
              <option value="desc">سعر تنازلي</option>
            </select>
          </div>
          <div className="w-[15px]" />
          <input
            type="submit"
            className="bg-primary rounded-md text-white h-full w-24 hover:cursor-pointer"
            value="بحث"
          />
        </form>
      </div>
    </div>
  );
};

export default LgSearch;
